'use strict';

// this should be the entry point to your library
module.exports = {
  VerticalTimeline: require('./VerticalTimeline').default, // eslint-disable-line global-require
  VerticalTimelineElement: require('./VerticalTimelineElement').default // eslint-disable-line global-require
};


//////////////////
// WEBPACK FOOTER
// ./~/react-vertical-timeline-component/dist-modules/index.js
// module id = 189
// module chunks = 114276838955818